import { createSelector } from 'reselect'

import { selectPlanningWizardState } from './selectPlanningWizardState'

export const selectWizardSteps = createSelector(
  [selectPlanningWizardState],
  (planningWizard) => planningWizard.wizardSteps
)
